import './InconsistenciesIndicator.scss';
import { defineComponent, h } from 'vue';

export default defineComponent({
    props: {
        visible: { required: true, type: Boolean },
        issues: { required: true, type: Number },
    },

    render() {
        return h('div', {
            id: 'inconsistencies',
            class: {
                hidden: !this.visible,
                'floating-text': true,
            },
        }, 'Issues: ' + this.issues);
    }
});
